import axios from "axios";

window.sessionStorage.removeItem("radio");

const devMode = false;

const consoleLog = (message, obj) => console.log(`[service.js]`, message, obj);

// https://admin-domain.fabriccamultimidia.com/login
// http://localhost:3000/?domain=energia97fm.fabriccaradio.com.br
class Service {
  getDomain() {
    const queryString = window.location.search.match(/\?domain=(.+)/);
    const domain = queryString ? queryString[1] : window.location.hostname;
    consoleLog("getDomain ->", domain);
    return domain;
  }

  getApiHost(uri = "/") {
    return devMode
      ? `http://127.0.0.1:8000${uri}`
      : `https://admin-domain.fabriccamultimidia.com${uri}`;
  }

  async getRadio(query) {
    const radioString = window.sessionStorage.getItem("radio");
    const hasQuery = typeof query === "string";
    if (radioString === null || hasQuery) {
      let radioObj = await axios({
        method: "GET",
        url: this.getApiHost("/api/radio"),
        headers: { domain: this.getDomain() },
      })
        .then((response) => response.data)
        .catch((error) => consoleLog("getRadio", error));

      if (!radioObj || radioObj.hasOwnProperty("error")) {
        consoleLog(
          "getRadio -> Falha ao obter dados da rádio a partir do domínio",
          radioObj
        );
        radioObj = {
          id: 0,
          name: "Fabriccaflix",
          logo: "/assets/img/logo.png",
          logo_height: 80,
          color_one: "#ed8600",
          color_two: "#1a1a1a",
          color_three: "#333333",
          text_color: "#ffffff",
          spacing: 15,
          videos_screen: 2.5,
          playlist_height: 300,
          playlists: [],
        };
      }
      if (radioObj.id > 0) {
        // Avisa o método componentDidMount do App.js que os metadados da rádio já estão diponíveis
        document.dispatchEvent(
          new CustomEvent("onLoadRadioMetadata", {
            detail: { radio: radioObj },
          })
        );

        // Agora vem a parte que demora, pegar todos os vídeos das playlists remotas (YouTube, etc)
        radioObj = await this.appendRemotePlaylists(radioObj, query);

        window.sessionStorage.setItem("radio", JSON.stringify(radioObj));
        consoleLog("getRadio -> Rádio obtida remotamente", radioObj);
      }
      return Promise.resolve(radioObj);
    } else {
      const radioObj = JSON.parse(radioString);
      consoleLog("getRadio -> Rádio obtida do cache", radioObj);
      return Promise.resolve(radioObj);
    }
  }

  async appendRemotePlaylists(radioObj, query) {
    const remotePlaylists = await axios({
      method: "GET",
      url: this.getApiHost(`/api/crawler/${radioObj.id}`),
      params: {
        q: query,
      },
      headers: { domain: this.getDomain() },
    })
      .then((response) => response.data)
      .catch((error) => consoleLog("appendRemotePlaylists", error));
    if (!remotePlaylists || remotePlaylists.hasOwnProperty("error")) {
      consoleLog(
        "appendRemotePlaylists -> Falha ao obter playlists remotas",
        remotePlaylists
      );
      return radioObj;
    }
    const remotePlaylistsByTitle = {};
    remotePlaylists.forEach(
      (remotePlaylist) =>
        (remotePlaylistsByTitle[remotePlaylist.title] = remotePlaylist)
    );

    // Detecta playlists do YouTube com o mesmo nome e mescla os vídeos
    radioObj.playlists.forEach((playlist, index) => {
      if (remotePlaylistsByTitle.hasOwnProperty(playlist.title)) {
        radioObj.playlists[index].videos = playlist.videos.concat(
          remotePlaylistsByTitle[playlist.title].videos
        );
        delete remotePlaylistsByTitle[playlist.title];
      }
    });

    // Acrescenta as playlists restantes do YouTube
    Object.keys(remotePlaylistsByTitle).forEach((title) =>
      radioObj.playlists.push(remotePlaylistsByTitle[title])
    );

    return radioObj;
  }
}

export default Service;
